import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/globals.scss';
import { App } from './app/App';
import { ServicesProvider } from './app/di';
import { createServices } from './app/services';
import { UiProviders } from './app/UiProviders';

const services = createServices();
document.documentElement.lang = services.i18n.locale.get();
// CFG-UC-1: до ответа действуют умолчания конфигурации, интерфейс не ждёт сервер.
void services.config.load();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ServicesProvider services={services}>
      <UiProviders>
        <App />
      </UiProviders>
    </ServicesProvider>
  </StrictMode>,
);
